<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y :left="left" :right="right" content-class="border-menu" max-height="345")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="240")
        .d-flex.align-center.fill-height.px-4
          .flex-grow-1.capitalize.text-left(v-if="selectedItem") {{ selectedItem }}
          .flex-grow-1.capitalize.neutral500--text.text-left(v-else) {{ $t('type_of_provider_placeholder') }} 
          v-icon(size=16) $yzi-chevron-down
    .text-xs.white
      .sticky.top-0.white
        v-text-field.my-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details)
        v-divider
        template(v-if="showCreateButton")
          .px-4.py-3
            a.info--text.font-semibold(@click="createType") {{ $t('create_provider_type') }} "{{ itemName }}"
          v-divider
      .px-4.py-3.font-semibold {{ $t('existing_type_of_provider') }}
      v-divider
      div(v-for="item in filteredItems")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-infoT08)")
          div.text-sm.flex-grow-1.neutral700--text {{ item }}
          div.text-xxs.neutral500--text {{ checkSystem(item) }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item }}
          div.text-xxs.neutral500--text {{ checkSystem(item) }}
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['items', 'selected', 'left', 'right' ],
  data: () => ({
    itemName: null,
    show: false,
    types: [
      { text: 'Regular text', value: 'string' },
      { text: 'Number', value: 'number' },
      { text: 'Date (DD/MM/YYYY)', value: 'date' }
    ],
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      systemProviders: 'clinic/getSystemProviders'
    }),
    showCreateButton() {
      if (this.itemName && !this.filteredItems.length) {
        return true
      }
      return false
    },
    filteredItems() {
      if (this.itemName) {
        const keyword = this.itemName.toLowerCase()
        return this.items.filter(item => (item.toLowerCase().includes(keyword)))
      }
      return this.items
    },
    selectedItem: {
      get () {
        return this.selected
      },
      set (newValue) {
        this.$emit('update:selected', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    createField () {
    },
    selectItem (item) {
      this.selectedItem = item
      this.show = false
      this.itemName = ''
    },
    isItemDisabled(item) {
      return this.selectedItem === item
    },
    checkSystem (item) {
      let sysitem = this.systemProviders.map(m => m.toLowerCase())
      if (sysitem.includes(item.toLowerCase())) {
        return 'System'
      }
      return ''
    },
    createType () {
      let ptypes = [...this.items]
      ptypes.push(this.itemName)
      this.$axios.patch(`/clinics/${this.company.slug}/`, { provider_types: ptypes })
        .then(() => {
          this.$emit('addItem')
          this.selectItem(this.itemName)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
</style>